import { Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { splitPathAndQueryParameters } from '../../../shared/helpers/routing.func';

/**
 * ```html
 * <lvr-tab
 *   [route]="['/some-route']"
 *   icon="home"
 *   label="Home"
 * ></lvr-tab>
 * ```
 */
@Component({
	selector: 'lvr-tab',
	template: `
		<a
			mat-tab-link
			[routerLink]="path()"
			[queryParams]="queryParams()"
			[class.active]="isActive()"
			[class.temporary]="temporary()"
		>
			<mat-icon class="material-symbols-outlined" [fontIcon]="icon()"></mat-icon>
			<span class="label"><ng-content></ng-content></span>
			@if (showDestroyButton()) {
				<mat-icon
					class="material-symbols-outlined"
					style="margin-left: 8px"
					fontIcon="close"
					(click)="onClose($event)"
				></mat-icon>
			}
		</a>
	`,
	styleUrl: './tabs.scss',
	imports: [RouterModule, MatIconModule],
})
export class Tab {
	public readonly route = input.required<string[]>();

	// split route to path without query parameters
	public readonly path = computed(() => {
		const data = splitPathAndQueryParameters(this.route().join(''));
		return data.path;
	});

	// now get the query parameters if any as { param: value }
	public readonly queryParams = computed(() => {
		const data = splitPathAndQueryParameters(this.route().join(''));
		return data.queryParams;
	});

	public readonly icon = input<string>('question_mark');

	public readonly isActive = input<boolean>(false);

	public readonly showDestroyButton = input<boolean>(true);

	public readonly temporary = input<boolean>(false);

	public readonly destroy = output<void>();

	public onClose(event: MouseEvent) {
		event.preventDefault();
		event.stopPropagation();
		this.destroy.emit();
	}
}
